var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	(function(linkTag) {
	                if (typeof _N_E_STYLE_LOAD === 'function') {
	                    const { href, onload, onerror } = linkTag;
	                    _N_E_STYLE_LOAD(href.indexOf(window.location.origin) === 0 ? new URL(href).pathname : href).then(()=>onload == null ? void 0 : onload.call(linkTag, {
	                            type: 'load'
	                        }), ()=>onerror == null ? void 0 : onerror.call(linkTag, {}));
	                } else {
	                    document.head.appendChild(linkTag);
	                }
	            })(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	8068: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"12":1,"70":1,"152":1,"177":1,"186":1,"189":1,"226":1,"332":1,"362":1,"475":1,"558":1,"628":1,"630":1,"771":1,"782":1,"958":1,"1138":1,"1186":1,"1379":1,"1419":1,"1483":1,"1520":1,"1772":1,"1931":1,"2015":1,"2035":1,"2108":1,"2271":1,"2363":1,"2425":1,"2495":1,"2569":1,"2802":1,"2835":1,"2894":1,"3034":1,"3072":1,"3270":1,"3342":1,"3488":1,"3633":1,"3756":1,"3800":1,"4007":1,"4024":1,"4103":1,"4185":1,"4254":1,"4364":1,"4522":1,"4612":1,"4732":1,"4778":1,"4867":1,"4893":1,"5201":1,"5216":1,"5285":1,"5491":1,"5497":1,"5513":1,"5645":1,"5820":1,"6033":1,"6127":1,"6147":1,"6177":1,"6193":1,"6551":1,"6958":1,"7080":1,"7148":1,"7201":1,"7363":1,"7375":1,"7447":1,"7452":1,"7502":1,"7525":1,"7691":1,"7951":1,"8073":1,"8227":1,"8320":1,"8401":1,"8527":1,"8591":1,"8739":1,"8750":1,"8870":1,"9120":1,"9141":1,"9391":1,"9599":1,"9706":1,"9837":1,"9985":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr